<template>
  <project-template title="配置病种模块" nextBtnText="下一步：随访表单" @lastClick="lastClick" :oneClickProject="true"
    @nextClick="nextClick" @gotoPage="gotoPage">
    <template v-slot:leftContent>
      <div class="module">
        <div class="title1">
          <recommand-module></recommand-module>
          <h3>已选择通用模块</h3>
        </div>
        <div class="wrap">
          <div class="list list1" v-if="options0.length !== 0">
            <a-checkbox default-checked disabled v-for="item in options0" :key="item.label" class="item">
              <recommand-module></recommand-module>
              <em>
                {{ item.name }}
              </em>
            </a-checkbox>
          </div>
          <a-empty v-else class="empty"></a-empty>
        </div>
      </div>
      <br>
      <div class="module">
        <div class="title1">
          <specialist-module></specialist-module>
          <h3>已选择专科模块</h3>
        </div>
        <div class="wrap">
          <div class="list list1" v-if="options1.length !== 0">
            <a-checkbox default-checked disabled v-for="item in options1" :key="item.label" class="item">
              <recommand-module></recommand-module>
              <em>
                {{ item.name }}
              </em>
            </a-checkbox>
          </div>
          <a-empty v-else class="empty"></a-empty>
        </div>
      </div>
    </template>
    <template v-slot:rightContent>
      <div class="module">
        <div class="title2">
          <h3>通用模块</h3>
          <span>已选{{ options0.length }}个</span>
        </div>
        <a-checkbox-group @change="onChange($event, 0)" v-model="options0" class="list list2">
          <a-checkbox :label="item.id" :value="item" v-for="item in options2" :key="item.label" class="item">
            <recommand-module></recommand-module>
            <em>
              {{ item.name }}
            </em>
          </a-checkbox>
        </a-checkbox-group>
      </div>
      <br>
      <div class="module">
        <div class="title2">
          <h3>专科模块</h3>
          <span>已选{{ options1.length }}个</span>
        </div>
        <a-checkbox-group @change="onChange($event, 1)" v-model="options1" class="list list2">
          <a-checkbox :label="item.id" :value="item" v-for="item in options3" :key="item.label" class="item">
            <recommand-module></recommand-module>
            <em>
              {{ item.name }}
            </em>
          </a-checkbox>
        </a-checkbox-group>
      </div>
    </template>
  </project-template>
</template>

<script>
import { getAction } from '@api/manage'
import ProjectTemplate from '@comp/pad/ProjectTemplate'
import RecommandModule from '@comp/Icon/RecommandModule'
import SpecialistModule from '@comp/Icon/SpecialistModule'
export default {
  name: 'StepThree',
  components: { ProjectTemplate, RecommandModule, SpecialistModule },
  data() {
    return {
      options0: [],
      options1: [],
      options2: [],
      options3: [],
      selectModule: [],
    }
  },
  watch: {
    data() {
    }
  },
  computed: {

  },
  mounted() {
    this.loadProjectData()
  },
  methods: {
    loadProjectData() {
      const id = this.$route.query.id
      getAction('/projectconfigview/configProject/queryById', { id }).then(res => {
        if (res.success) {
          // console.log("res.result.moduleJson:"+res.result.moduleJson)
          const moduleData = JSON.parse(res.result.moduleJson)
          for (let key in moduleData) {
            if(moduleData[key]){
              moduleData[key].map(item=>{
                this.selectModule.push(item.code)
              })              
            }
          }
          // moduleData.map(item=>)
          const data = JSON.parse(res.result.diseaseJson)          
          this.loadData(data.map(item => item.id).join(','))
        }
      })
    },
    loadData(diseaseIds) {
      // diseaseCode: 'AAA','TEST1'
      getAction('/projectconfigview/configModule/list2', { diseaseId: diseaseIds }).then(res => {
        if (res.success) {
          res.result.forEach(item => {
            if (item.type === '1') {
              this.options2.push(item)
              if(this.selectModule && this.selectModule.indexOf(item.code)!== -1){
                this.options0.push(item)
              }
            } else {
              this.options3.push(item)
              if(this.selectModule && this.selectModule.indexOf(item.code)!== -1){
                this.options1.push(item)
              }
            }
          });
        }
      })
    },
    onChange(checkedValues, n) {
      this[`options${n}`] = checkedValues
    },
    nextClick() {
      const arr = [...this.options0, ...this.options1]
      if (arr.length === 0) {
        return this.$message.warning('请至少选择一个模块')
      }
      // const moduleCodes = arr.map(item => item.code).join(',')
      // console.log("selectedModule:"+JSON.stringify(arr))
      sessionStorage.setItem('selectedModule', JSON.stringify(arr))
      // this.$emit('changeCur',1)
      this.$emit('next')
    },
    lastClick() {
      this.$emit('last')
    },
    gotoPage(page){
      this.$emit('gotoPage', page)
    },
  }
}
</script>

<style scoped lang="less">
.empty {
  color: white;
}

.module {
  .title1 {
    display: flex;
    align-items: center;
    column-gap: 10px;

    h3 {
      font-size: 18px;
      color: white;
      margin: 0;
    }
  }

  .title2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 10px;

    h3 {
      font-size: 18px;
      color: white;
      margin: 0;
    }

    span {
      font-weight: 400;
      font-size: 12x;
      color: rgba(255, 255, 255, 0.7);
    }
  }

  .wrap {
    min-height: 200px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  .list1 {
    grid-template-columns: repeat(2, 1fr);
  }

  .list2 {
    grid-template-columns: repeat(4, 1fr);

    /deep/ .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #376eff;
      border-color: #376eff;
    }
  }

  .list {
    width: 100%;
    display: grid;
    grid-gap: 10px;
    justify-content: center;
    margin-top: 10px;

    .item {
      position: relative;
      height: 80px;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 12px;
      margin-left: 0;

      /deep/ .ant-checkbox {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }

      /deep/ .ant-checkbox+span {
        display: flex;
        flex-direction: column;
        margin-top: 18px;
      }

      em {
        font-style: normal;
        color: white;
      }
    }
  }
}
</style>
